import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: 'flex',
    gap: SPACES.xxxs,
  },
  iconWrapper: {
    '&&': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      filter: `drop-shadow(0px 0px 4px ${theme.palette.custom.shadowMain})`,
      overflow: 'hidden',
      cursor: 'pointer',

      [theme.breakpoints.down('laptop')]: {
        width: 32,
        height: 32,

        cursor: 'pointer',
      },
      [theme.breakpoints.up('laptop')]: {
        width: 50,
        height: 50,
      },
    },
  },
  icon: {
    '&&': {
      with: 'inherit',
      height: 'inherit',
      cursor: 'pointer',
    },
  },
  defaultIcon: {
    '&&': {
      color: theme.palette.custom.darkBlue2,
      cursor: 'pointer',

      [theme.breakpoints.up('laptop')]: {
        width: 30,
        height: 30,
      },
    },
  },
  moreButton: {
    '&&': {
      height: 34,
      alignSelf: 'center',

      [theme.breakpoints.down('laptop')]: {
        display: 'none',
      },
    },
  },
  popOverIconWrapper: {
    '&&': {
      minWidth: 40,
    },
  },
  popOverIcon: {
    '&&': {
      color: theme.palette.custom.darkBlue2,
    },
  },
  popOverPrimary: {
    '&&': {
      color: theme.palette.custom.darkBlue2,
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.m,
    },
  },

  wrapText: {
    '&&': {
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      // hyphens: 'auto',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      maxWidth: '175px',
    },
  },
  popOverLight: {
    '&&': {
      color: theme.palette.custom.primary,
      fill: theme.palette.custom.primary,
    },
  },
  primaryAccent: {
    '&&': {
      color: theme.palette.custom.primary,
    },
  },
  popOverDescr: {
    '&&': {
      color: theme.palette.custom.grey2,
      fontSize: FONTS.SIZES.s,
    },
  },
  popOverRole: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.custom.grey3,
      fontSize: FONTS.SIZES.xs,
    },
  },
  listItem: {
    '&&': {
      padding: `${SPACES.xxs} ${SPACES.l} 0 ${SPACES.l}`,
    },
  },
  listItem2: {
    '&&': {
      padding: `0 ${SPACES.l} 0 ${SPACES.l}`,
    },
  },
  themeSwitchLabel: {
    '&&': {
      margin: 0,
      color: theme.palette.custom.darkBlue2,
      fontSize: FONTS.SIZES.m,
    },
  },
  addressWrapper: {
    display: 'flex',
    gap: SPACES.xxxs,
    alignItems: 'center',
  },
  addressText: {
    margin: 0,

    fontSize: FONTS.SIZES.m,
    color: theme.palette.custom.darkBlue2,
  },
  copyIcon: {
    '&&': {
      color: theme.palette.custom.darkBlue2,
      width: 16,
      height: 16,
    },
  },
}))
export { useStyles }
